import aajc from './aajc.jpg'
import aja from './aja.jpg'
import ajc from './ajc.jpg'
import ajla from './ajla.jpg'
import alc from './alc.jpg'

export const orgImages ={
  aajc: aajc,
  aja: aja,
  ajc: ajc,
  ajla: ajla,
  alc: alc
}